import { ajax } from 'rxjs/ajax';
import {
  map,
  catchError,
  finalize
} from 'rxjs/operators';
import { throwError } from 'rxjs';
import { openSnackbar } from 'helpers/Notifier';
import { openConfirmation } from 'helpers/Confirmation';
import { httpStatusEnum } from 'appconstants';

function showMsgToUser(msg, name, type = 'error') {
  openSnackbar({
    message: msg || 'Unknown error. Please contact the CTSU Help Desk at 1-888-823-5923',
    variant: type,
    name
  });
}

const http = {
  PUT: (url, loggerInfo, body = {}) => ajax({
    method: 'PUT',
    body,
    headers: {
      appName: process.env.REACT_APP_NAME,
      'Content-Type': 'application/json'
    },
    url: process.env.REACT_APP_ORIGIN + url,
    crossDomain: true,
    withCredentials: true,
    responseType: 'json'
  }).pipe(
    map(res => http.responseHandler(res, loggerInfo)),
    catchError(error => http.errorHandler(error, loggerInfo))
  ),
  getStreamWithToken: (url, token, loggerInfo, body = {}) => ajax({
    method: 'GET',
    body,
    headers: {
      Authorization: `Bearer ${token}`
    },
    url: process.env.REACT_APP_ORIGIN + url,
    crossDomain: false,
    withCredentials: true,
    responseType: 'blob'
  }).pipe(
    map(res => http.responseHandler(res, loggerInfo)),
    catchError(error => http.errorHandler(error, loggerInfo)),
    finalize(() => http.endReqHanlder(url, loggerInfo))
  ),
  getWithToken: (url, token, loggerInfo, body = {}) => {
    return ajax({
      method: 'GET',
      body,
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json'
      },
      url: process.env.REACT_APP_ORIGIN + url,
      crossDomain: false,
      withCredentials: true,
      responseType: 'json'
    }).pipe(
      map(res => http.responseHandler(res, loggerInfo)),
      catchError(error => http.errorHandler(error, loggerInfo)),
      finalize(() => http.endReqHanlder(url, loggerInfo))
    );
  },
  putWithToken: (url, token, loggerInfo, body = {}) => {
    // remove _parsed keys from the request objet to resolve 606 issue -- START
    let requestObj = body;
    try {
      requestObj = JSON.parse(body);
      if (typeof requestObj === 'object') {
        requestObj = Object.keys(requestObj).reduce((p, c) => {
          if (c.includes('_parsed')) {
            return p;
          }
          return {
            ...p,
            [c]: requestObj[c]
          }
        }, {});
        requestObj = JSON.stringify(requestObj);
      }
    } catch (e) {
      requestObj = body;
    }
    // -- END
    return ajax({
      method: 'PUT',
      body: requestObj,
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json'
      },
      url: process.env.REACT_APP_ORIGIN + url,
      crossDomain: false,
      withCredentials: true
    }).pipe(
      map(res => http.responseHandler(res, loggerInfo)),
      catchError(error => http.errorHandler(error, loggerInfo)),
      finalize(() => http.endReqHanlder(url, loggerInfo))
    );
  },
  deleteWithToken: (url, token, loggerInfo, body = {}) => {
    return ajax({
      method: 'DELETE',
      body,
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json'
      },
      url: process.env.REACT_APP_ORIGIN + url,
      crossDomain: false,
      withCredentials: true
    }).pipe(
      map(res => http.responseHandler(res, loggerInfo)),
      catchError(error => http.errorHandler(error, loggerInfo)),
      finalize(() => http.endReqHanlder(url, loggerInfo))
    );
  },
  postWithToken: (url, token, loggerInfo, body = {}) => {
    return ajax({
      method: 'POST',
      body,
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json'
      },
      url: process.env.REACT_APP_ORIGIN + url,
      crossDomain: false,
      withCredentials: true,
      responseType: 'json'
    }).pipe(
      map(res => http.responseHandler(res, loggerInfo)),
      catchError(error => http.errorHandler(error, loggerInfo)),
      finalize(() => http.endReqHanlder(url, loggerInfo))
    );
  },
  get: (url, responseType = 'json', key = null) => {
    const headers = {
      appName: process.env.REACT_APP_NAME,
      'Content-Type': 'application/json'
      // key
    };
    return ajax({
      method: 'GET',
      headers,
      url: process.env.REACT_APP_ORIGIN + url,
      crossDomain: true,
      withCredentials: true,
      responseType
    }).pipe(
      map(res => res),
      catchError(error => http.errorHandler(error))
    );
  },
  responseHandler: (resp, loggerInfo) => resp,
  errorHandler: (error, loggerInfo) => {
    let showError = true;
    const { message, statusCode } = error.response || {};

    const confirmOk = () => {};
    switch (statusCode) {
      case httpStatusEnum.UNDEFINED:
        break;
      case httpStatusEnum.UNAUTHORIZED:
        break;
      case httpStatusEnum.INTERNAL_SERVER_ERROR:
        break;
      case httpStatusEnum.ANY_OTHER_EXCEPTION:
        break;
      case httpStatusEnum.NOT_AUTHORIZED:
        break;
      case httpStatusEnum.NOT_FOUND_DAO:
        break;
      case httpStatusEnum.IMAGE_UPLOAD_EXCEPTION:
        break;
      case httpStatusEnum.DOWNLOAD_EXCEPTION:
        break;
      case httpStatusEnum.BAD_REQUEST:
        break;
      case httpStatusEnum.NOT_VALID_ACTION_EXCEPTION:
        showError = false;
        openConfirmation({
          message,
          title: 'Validation Error',
          onAction: confirmOk,
          name: 'no_validation',
          hideButton1: true,
          btn2: 'Close'
        });
        break;
      default:
        break;
    }

    if (showError) {
      showMsgToUser(message, 'report');
    }
    return throwError(error);
  },
  initReqHanlder: (url, loggerInfo, method) => {
  },
  endReqHanlder: (url, loggerInfo) => {
  }
};


export default http;
